import type { Bounds, EditorItem } from '../Reducers/Configurator/types';
import { emptyBounds } from '../Reducers/Configurator/types';

export function computeDesignSize(objects: Record<string, EditorItem>): Bounds {
  const items = Object.values(objects);
  if (items.length === 0) {
    return emptyBounds();
  }

  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  for (const item of items) {
    minX = Math.min(minX, item.x);
    minY = Math.min(minY, item.y);
    maxX = Math.max(maxX, item.x + item.width);
    maxY = Math.max(maxY, item.y + item.height);
  }

  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY,
  };
}

export function centerOfBounds(bounds: Bounds) {
  return {
    x: bounds.x + bounds.width / 2,
    y: bounds.y + bounds.height / 2,
  };
}

/** Keep an item's axis-aligned box inside the canvas (0 … canvasW/H). */
export function clampItemPosition(
  x: number,
  y: number,
  width: number,
  height: number,
  canvasW: number,
  canvasH: number
): { x: number; y: number } {
  const minX = Math.min(0, canvasW - width);
  const maxX = Math.max(0, canvasW - width);
  const minY = Math.min(0, canvasH - height);
  const maxY = Math.max(0, canvasH - height);

  return {
    x: Math.min(maxX, Math.max(minX, x)),
    y: Math.min(maxY, Math.max(minY, y)),
  };
}

export function clampEditorItemPosition(
  item: EditorItem,
  canvasW: number,
  canvasH: number
): EditorItem {
  const { x, y } = clampItemPosition(item.x, item.y, item.width, item.height, canvasW, canvasH);
  if (x === item.x && y === item.y) {
    return item;
  }
  return { ...item, x, y };
}
